import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, CircularProgress } from "@mui/material";

interface ConfirmDeleteDialogProps {
  open: boolean;
  title: string;
  message: string;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  confirmLabel?: string;
}

// Genérico de propósito (não é só do módulo de Médicos) — qualquer tela com
// "clique na lixeira exclui direto" pode reaproveitar este componente em vez
// de duplicar a mesma trava de segurança.
// PaperProps aqui não usa tokens de tema MUI ("background.paper" etc.) —
// este app não tem ThemeProvider, então esses tokens sempre resolveriam pro
// tema claro padrão do MUI. As CSS vars do design system (var(--surface)…)
// são as únicas que acompanham o dark mode real do app.
const ConfirmDeleteDialog: React.FC<ConfirmDeleteDialogProps> = ({
  open,
  title,
  message,
  loading = false,
  onCancel,
  onConfirm,
  confirmLabel = "Excluir",
}) => {
  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onCancel}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          bgcolor: "var(--surface)",
          color: "var(--ink)",
          border: "1px solid var(--border)",
          borderRadius: "var(--radius-md)",
        },
      }}
    >
      <DialogTitle sx={{ fontWeight: 800 }}>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ color: "var(--ink-soft)" }}>{message}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button onClick={onCancel} disabled={loading} sx={{ color: "var(--ink-soft)" }}>
          Cancelar
        </Button>
        <Button onClick={onConfirm} disabled={loading} color="error" variant="contained" disableElevation>
          {loading ? <CircularProgress size={18} sx={{ color: "#fff" }} /> : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteDialog;
